import apiClient from '../../../api/apiClient';
import { SYSTEM_REST_API_BASE_URL } from '../../../config';
const REST_API_BASE_URL = SYSTEM_REST_API_BASE_URL;

export const getAllProducts = () =>
  apiClient.get(REST_API_BASE_URL + '/products');

export const saveProduct = (product) =>
  apiClient.post(REST_API_BASE_URL + '/product', product);

export const getProduct = (id) =>
  apiClient.get(`${REST_API_BASE_URL}/product/${id}`);

export const updateProduct = (id, product) =>
  apiClient.put(`${REST_API_BASE_URL}/product/${id}`, product);

export const deleteProduct = (id) =>
  apiClient.delete(`${REST_API_BASE_URL}/product/${id}`);

export const addAppToProduct = (id, appid) =>
  apiClient.post(`${REST_API_BASE_URL}/product/${id}/app/${appid}`);

export const removeAppFromProduct = (id, appid) =>
  apiClient.delete(`${REST_API_BASE_URL}/product/${id}/app/${appid}`);

// export const addItemToProduct = (id, itemid) => apiClient.post(`${REST_API_BASE_URL}/product/${id}/item/${itemid}`);

// export const removeItemFromProduct = (id, itemid) => apiClient.delete(`${REST_API_BASE_URL}/product/${id}/item/${itemid}`);

export const getAllAppsByProduct = (id) =>
  apiClient.get(`${REST_API_BASE_URL}/product/${id}/apps`);

export const getAllItemsByProduct = (id) =>
  apiClient.get(`${REST_API_BASE_URL}/product/${id}/items`);

export const getAllApps = () => apiClient.get(`${REST_API_BASE_URL}/apps`);

export default apiClient;
